module.exports = __webpack_public_path__ + "static/media/exercise-badge.872d76c0.svg";